import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestSearchResultDto, RequestsSearchDto } from 'src/app/modules/workFlow/models/request-models';
import { ApiResponse } from 'src/app/shared/models/api-response.model';
import { SearchDto1 } from 'src/app/shared/models/paging/request/search-dto';


import { HttpClient } from '@angular/common/http';
import { Paginator } from 'src/app/shared/models/paginator.model';
import { notificationDto } from '../models/notificationDto';
import { getQueryString } from 'src/app/shared/helpers/query.string';

@Injectable({
  providedIn: 'root'
})
export class NotificationsServicesService {

  constructor(private http: HttpClient) { }

  // FilterNotifications(params): Observable<ApiResponse<Paginator<notificationDto>>> {
  //     let httpParams = params ? getQueryString(params) : {};
  //     return this.http.get<ApiResponse<Paginator<notificationDto>>>( '/api/Notifications/FilterNotifications', { params: httpParams });
  //   }

    FilterNotifications(requestsSearchDto: SearchDto1<notificationDto> ): Observable<ApiResponse<SearchDto1<notificationDto>>> {
      return this.http.post<ApiResponse<SearchDto1<notificationDto>>>('/api/Notifications/FilterNotifications', requestsSearchDto);
    }
  GetNewNotificationLogsCount(): Observable<any> {
    return this.http.get<any>('/api/Notifications/GetNewNotificationLogsCount');
  }

  GetNewNotificationLogs(): Observable<any> {
    return this.http.get<any>('/api/Notifications/GetNewNotificationLogs');
  }

  GetAllNotifications(): Observable<any> {
    return this.http.get<any>('/api/Notifications/GetAllNotifications');
  }
}
